import { useId, type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';

import { Select } from '@/components/ui/select';
import { tenantQueries } from '@/features/patient-record/queries';

import { Field } from './Field';

interface MetadataFieldsProps {
  readonly program: string;
  readonly onProgramChange: (next: string) => void;
}

/** Program dropdown for the care-team editor. */
export function MetadataFields({
  program,
  onProgramChange,
}: MetadataFieldsProps): ReactElement {
  const { t } = useTranslation();
  const programsQuery = useQuery(tenantQueries.programs());
  const programId = useId();

  return (
    <Field htmlFor={programId} label={t('patient.careTeam.program')}>
      <Select
        id={programId}
        value={program}
        disabled={programsQuery.isPending}
        onChange={(event) => {
          onProgramChange(event.target.value);
        }}
        className="h-9 text-sm"
      >
        <option value="">{t('patient.careTeam.programNone')}</option>
        {programsQuery.data?.map((p) => (
          <option key={p.id} value={p.name}>
            {p.name}
          </option>
        ))}
      </Select>
    </Field>
  );
}
